module.exports = __webpack_public_path__ + "img/ice_pellets.f090e789.svg";